__turbopack_context__.v({
  "className": "noto_serif_1ccecbe2-module__s-4dVq__className",
});
